import { FC } from 'react';
import { ID } from '@/data/types/Basic';
import { useSettings } from '@/data/Settings';
import { FooterDesktop } from '@/components/content/Footer/parts/FooterDesktop';
import { FooterMobile } from '@/components/content/Footer/parts/FooterMobile';
import { useMediaQuery } from '@mui/material';

export const Footer: FC<{
	id: ID;
	clickAction?: () => void;
}> = ({ id }) => {
	const { settings } = useSettings();
	const isMobile = useMediaQuery(`(max-width:1280px)`);

	if (isMobile) {
		return <FooterMobile settings={settings} />;
	}

	return <FooterDesktop id={id} settings={settings} />;
};
